.page {
  padding: 20px;

  input,
  button,
  textarea {
    width: 100%;
    padding: 15px 20px;
    background-color: #f5f5f5;
    border-radius: 15px;
    margin-bottom: 15px;
    font-size: 16px;
  }

  textarea {
    height: 200px;
  }

  img {
    width: 350px;
    border: 1px solid #000000;
    margin-bottom: 15px;
  }
}
